"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normaliseHttpHeaderMapping = exports.normaliseHttpHeaderKey = exports.ensureHttpHeaderMapping = void 0;
/**
 * Ensures the given value is an object that can be used as {@link HttpHeaderMapping}.
 * If not an empty object is returned, allowing for easier header merges.
 */
const ensureHttpHeaderMapping = (value) => {
    if (typeof value === 'object' && value !== null) {
        return value;
    }
    return {};
};
exports.ensureHttpHeaderMapping = ensureHttpHeaderMapping;
/**
 * Normalise the given {@link HttpHeaderKey} of type {@link Key}.
 *
 * This will convert the key's casing to lowercase.
 */
const normaliseHttpHeaderKey = (key) => {
    return key.toLowerCase();
};
exports.normaliseHttpHeaderKey = normaliseHttpHeaderKey;
/**
 * Normalise the given {@link HttpHeaderMapping} of type {@link Headers}.
 *
 * To normalise a header mapping we convert every key within the mapping to lowercase.
 * This is because keys are not case sensitive and will allow for a more consistent interaction with header mappings.
 */
const normaliseHttpHeaderMapping = (headers) => {
    return Object.fromEntries(Object.entries(headers).map(([key, value]) => {
        return [
            (0, exports.normaliseHttpHeaderKey)(key),
            value,
        ];
    }));
};
exports.normaliseHttpHeaderMapping = normaliseHttpHeaderMapping;
